import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from '../../Components/utils/Loader';
import { Link } from 'react-router-dom';
import { FaChevronDown, FaChevronRight, FaArrowRight } from 'react-icons/fa';
import SEO from '../../Components/utils/SEO';

function FAQPage() {
    const [data, setData] = useState({ categories: [] });
    const [isLoading, setIsLoading] = useState(true);
    const [expandedId, setExpandedId] = useState(null);
    const [openCategory, setOpenCategory] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/faq/full`)
            .then(res => {
                if (res.data.success) {
                    setData({ categories: res.data.categories || [] });
                    if (res.data.categories?.length) {
                        setOpenCategory(res.data.categories[0]?._id);
                    }
                }
            })
            .finally(() => setIsLoading(false));
    }, []);

    const toggleFaq = (id) => {
        setExpandedId(prev => prev === id ? null : id);
    };

    const toggleCategory = (id) => {
        setOpenCategory(prev => prev === id ? null : id);
    };

    return (
        <div className="faqPage">
            <SEO
                title="Help centre and FAQs"
                description="Find answers to common questions about Chocowi, orders, sellers, and support."
                canonicalPath="/faq"
            />
            <div className="faqPageContent">
                <div className="faqPageHeader">
                    <h1 className="primaryHeading">Help Centre</h1>
                    <p className="faqPageSubtitle">Find answers to commonly asked questions. Can&apos;t find what you need? <Link to="/contact">Contact us</Link>.</p>
                </div>

                {isLoading ? (
                    <Loader type="simpleMini" />
                ) : data.categories.length === 0 ? (
                    <div className="faqEmptyState">
                        <p>No FAQs available at the moment. Check back soon!</p>
                    </div>
                ) : (
                    <div className="faqCategoriesWrapper">
                        {data.categories.map(cat => (
                            <div
                                key={cat._id}
                                className="faqCategoryBlock"
                                style={{
                                    '--cat-color': cat.color || '#667eea',
                                    '--cat-bg': cat.backgroundColor || '#f8f9ff'
                                }}
                            >
                                <button
                                    type="button"
                                    className={`faqCategoryHeader ${openCategory === cat._id ? 'open' : ''}`}
                                    onClick={() => toggleCategory(cat._id)}
                                >
                                    <span className="faqCategoryIcon" style={{ background: cat.color || '#667eea' }}></span>
                                    <span className="faqCategoryTitle">{cat.name}</span>
                                    {openCategory === cat._id ? <FaChevronDown /> : <FaChevronRight />}
                                </button>
                                {openCategory === cat._id && (
                                    <div className="faqCategoryBody">
                                        {(!cat.faqs || cat.faqs.length === 0) ? (
                                            <p className="faqNoItems">No questions in this category yet.</p>
                                        ) : (
                                            cat.faqs.map(item => (
                                                <div
                                                    key={item._id}
                                                    className={`faqItem ${expandedId === item._id ? 'expanded' : ''}`}
                                                >
                                                    <button
                                                        type="button"
                                                        className="faqQuestion"
                                                        onClick={() => toggleFaq(item._id)}
                                                    >
                                                        <span>{item.question}</span>
                                                        {expandedId === item._id ? <FaChevronDown /> : <FaChevronRight />}
                                                    </button>
                                                    {expandedId === item._id && (
                                                        <div className="faqAnswer">
                                                            <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                                                        </div>
                                                    )}
                                                </div>
                                            ))
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                <div className="faqCta">
                    <p>Still have questions?</p>
                    <Link to="/contact" className="faqCtaLink">
                        Get in touch <FaArrowRight />
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default FAQPage;
